if (!customElements.get("product-upsell")) {
  customElements.define(
    "product-upsell",
    class UpsellProduct extends HTMLElement {
      constructor() {
        super();
        const productUpsellContainer = this.querySelector(
          ".product-upsell__container",
        );
        if (!productUpsellContainer) return;

        var upsellSlider = new Flickity(productUpsellContainer, {
          lazyLoad: 4,
          pageDots: true,
          wrapAround: true,
          prevNextButtons: false,
        });
      }
    },
  );
}
